module.exports = __webpack_public_path__ + "Roboto-Bold.eed9aab5449cc9c8430d";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module chunks = styles